import styled from 'styled-components';
import {mobileMedia, LIGHT_BLUE4, GRAY, FAILED_RED, BGImageCenter, scrollbar} from '../../../globalVariables/GlobalVariables';
import {dFlexColumn, dFlexEnd} from '../../../globalVariables/GlobalFlex';
import { popTitle } from '../../newPopup/topPopup/TopPopup.css';
import {search} from '../../../assets/symbols/symbols/Symbols.css';

export const content = styled.div`
    padding: 0 23px 23px 23px;
    position: relative;
    height: 90%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    ${mobileMedia} {
        padding: 0 15px 30px 15px;
    }
`;

export const leadsList = styled.div`
    ${dFlexColumn}
    gap: 10px;
    margin-bottom: 20px;
`;

export const error = styled.div`
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: ${FAILED_RED};
`;

export const searchContainer = styled.div`
    margin-bottom: 20px;
    position: relative;
    flex-shrink: 0;
    
    &::after{
        content:"";
        ${BGImageCenter(search, '10px')}
        width: 10px;
        position: absolute;
        height: 10px;
        inset-inline-end: 19px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
    }
`;

export const searchInput = styled.input`
    width: 100%;
    padding: 12px 16px 12px 40px;
    border: 1px solid ${GRAY};
    border-radius: 29px;
    font-size: 14px;
    outline: none;
    
    &:focus {
        border-color: ${LIGHT_BLUE4};
    }
`;

export const scrollableContainer = styled.div`
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    ${scrollbar}
`;

export const popupBottom = styled.div`
    ${dFlexEnd}
    flex-shrink: 0;
`;

export const separator = styled.div`
    height: 1px;
    background-color: ${GRAY};
    margin: 20px 0;
    width: 100%;
`;

export const sectionTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #333;
`;